import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import * as styles from './QuickLinkItem.css';
import { trackQuickLinkClick } from '../../../../utils/tracking';

export interface IQuickLinkItemProps {
  level: number;
  url: string;
  offersCount: number | null;
  title: string;
}

export function QuickLinkItem(props: IQuickLinkItemProps) {
  const { level, url, title, offersCount } = props;
  const handleClick = () => {
    trackQuickLinkClick(level, url, title);
  };

  if (!offersCount) {
    return null;
  }

  return (
    <a href={url} onClick={handleClick} className={styles['link']}>
      <span className={styles['link-title']}>{title}</span>
      &nbsp;
      <span className={styles['link-count']}>{numberToPrettyString(offersCount)}</span>
    </a>
  );
}
